/**
 * @generated SignedSource<<0083cd5485245cc73bf32efdd23c178d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateHotelInput = {
  name: string;
};
export type HotelListAddMutation$variables = {
  input: CreateHotelInput;
};
export type HotelListAddMutation$data = {
  readonly createHotel: {
    readonly node: {
      readonly id: string;
    } | null;
  };
};
export type HotelListAddMutation = {
  response: HotelListAddMutation$data;
  variables: HotelListAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateHotelResult",
    "kind": "LinkedField",
    "name": "createHotel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Hotel",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HotelListAddMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HotelListAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3a3ec5e723f3765fb90f9a1ac62c677c",
    "id": null,
    "metadata": {},
    "name": "HotelListAddMutation",
    "operationKind": "mutation",
    "text": "mutation HotelListAddMutation(\n  $input: CreateHotelInput!\n) {\n  createHotel(input: $input) {\n    node {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "05040dc3930b878b14129332e92a5863";

export default node;
